@if (show) {
  <div>
    <div class="modal-header">
      <h5 class="text-danger">{{ title }}</h5>
      <button type="button"
        class="close"
        aria-label="Close"
        (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <strong>{{ message }}</strong>
      @if (violations && violations.length) {
        <div data-id="violations-list"
          class="more-details-form">
          <div class="header">
            <div (click)="isCollapsed = !isCollapsed">
              @if (!isCollapsed) {
                <reporter-icon
                icon="Expanded"></reporter-icon>
              }
              @if (isCollapsed) {
                <reporter-icon
                icon="Collapsed"></reporter-icon>
              }
              <span class="pl-2">More details</span>
            </div>
          </div>
          <div id="collapse"
            [ngbCollapse]="isCollapsed">
            <div class="card">
              <ul class="bullet">
                @for (violation of violations; track violation) {
                  <li  class="card-body">{{ violation.message }}</li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
